import { render, staticRenderFns } from "./MatchSignupPaymentDetail.vue?vue&type=template&id=1295b031&scoped=true&"
import script from "./MatchSignupPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./MatchSignupPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./MatchSignupPaymentDetail.vue?vue&type=style&index=0&id=1295b031&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295b031",
  null
  
)

export default component.exports